<script>
  import { onMount } from "svelte";
  import { persist } from "../stores/store";

  let time = new Date();

  $: strTime = "";

  onMount(() => {
    const interval = setInterval(() => {
      time = new Date();
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let ampm = "";
      ampm = hours >= 12 ? "pm" : "am";
      localStorage.setItem("hour", hours);
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      strTime = hours + ":" + minutes + " " + ampm;
    }, 1000);
    return () => {
      localStorage.removeItem("hour");
      clearInterval(interval);
    };
  });
</script>

<style>
  div {
    display: flex;
    justify-content: center;
    margin-top: -20px;
  }

  p {
    font-size: 3vh;
    filter: drop-shadow(-5px 5px 5px rgba(0, 0, 0, 0.3));
  }
</style>

<div>
  <p>{strTime}</p>
</div>
